var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('div',{staticClass:"button-list"},_vm._l((_vm.linkList),function(item,index){return _c('div',{key:item.value,staticClass:"button-item",class:{active: index === _vm.active},on:{"click":function($event){return _vm.itemclick(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }